import TeamsProjectsPage from '../shared/tickets/teams/TeamsProjectsPage';

export default TeamsProjectsPage;
